import { Alert, Typography } from "@octopus-energy/coral/atoms"
import { useCapsLock } from "@octopus-energy/utils"
import { useTranslations } from "next-intl"

export function CapsLockWarning() {
    const t = useTranslations("CapsLockWarning")
    const isCapsLockOn = useCapsLock()

    if (!isCapsLockOn) {
        return null
    }

    return (
        <Alert severity="warning">
            <Typography color="inherit">{t("message")}.</Typography>
        </Alert>
    )
}

CapsLockWarning.messages = ["CapsLockWarning"] as const
